/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from "react";
import { Box, Center, Flex, Text } from "@mantine/core";
import { GraphQLQuery, generateClient } from "@aws-amplify/api";
import CaseDetailConfirmDeleteModal from "@/components/Case/ConfirmDeleteModal";
import { deleteDetails } from "@/graphql/mutations";
import {
  DeleteDetailsInput,
  DeleteDetailsMutation,
  DeleteDetailsMutationVariables,
} from "@/API";
import BtnSummarize from "../BtnSummarize";
import DetailCard from "../DetailCard";
import DetailSection from "../DetailSection";

const client = generateClient();

interface TabPanelTranscriptionProps {
  details: any;
  styles: any;
  loading: boolean;
  handleSummarize: (sectionName: string) => void;
}
const TabPanelTranscription = ({
  styles,
  details,
  loading,
  handleSummarize,
}: TabPanelTranscriptionProps) => {
  const [confirmDeleteItem, setConfirmDeleteItem] = useState<any>(null);
  const [deleting, setDeleting] = useState(false);
  const getSectionDetailCount = (section: string) => {
    return details?.filter((item: any) => {
      if (item.type == section) return true;
    }).length;
  };

  const renderSectionItem = ({
    title = "",
    sectionName = "",
    isSummarized = false,
  }) => {
    const isEmpty = getSectionDetailCount(sectionName) === 0;
    if (isEmpty) {
      return null;
    }
    const items = details.filter((item: any) => item.type == sectionName);
    return (
      <DetailSection title={title}>
        {items.map((item: any, index: number) => (
          <DetailCard
            key={index}
            createdAt={item.createdAt}
            text={item.text}
            isSummarized={item.isSummarized}
            hideDeleteAction={
              item.isSummarized || item.sectionName === "COMMUNICATION"
            }
            onDelete={() => setConfirmDeleteItem(item)}
          />
        ))}

        {isSummarized && (
          <Flex flex={1} align={"center"} justify={"center"}>
            <BtnSummarize
              section={sectionName}
              handleSummarize={handleSummarize}
            />
          </Flex>
        )}
      </DetailSection>
    );
  };

  const handleDeleteItem = async () => {
    if (!confirmDeleteItem) return;
    setDeleting(true);
    const deleteDetailInput: DeleteDetailsInput = {
      id: confirmDeleteItem.id,
      _version: confirmDeleteItem._version,
    };
    const deleteDetailVars: DeleteDetailsMutationVariables = {
      input: deleteDetailInput,
    };
    try {
      await client.graphql<GraphQLQuery<DeleteDetailsMutation>>({
        query: deleteDetails,
        variables: deleteDetailVars,
      });
    } catch (err) {
      console.error(err);
    } finally {
      setConfirmDeleteItem(null);
      setDeleting(false);
    }
  };

  return (
    <Box style={styles} pos={"relative"} w={"100%"}>
      {details.length === 0 && !loading ? (
        <Center>
          <Text>No existing recordings. Tap "Record" to create one!</Text>
        </Center>
      ) : null}
      {/* Repeat for sections: HISTORY */}
      {renderSectionItem({
        title: "History",
        sectionName: "HISTORY",
        isSummarized: true,
      })}
      {/* Repeat for sections: HISTORY */}
      {renderSectionItem({
        title: "Exam",
        sectionName: "EXAM",
        isSummarized: false,
      })}

      {/* Repeat for sections: HISTORY */}
      {renderSectionItem({
        title: "Assessment",
        sectionName: "ASSESSMENT",
        isSummarized: false,
      })}

      {/* Repeat for other sections: PLAN */}
      {renderSectionItem({
        title: "Plan",
        sectionName: "PLAN",
        isSummarized: true,
      })}

      {/* Repeat for other sections: COMMUNICATION */}
      {renderSectionItem({
        title: "Communication",
        sectionName: "COMMUNICATION",
        isSummarized: false,
      })}

      {/* Repeat for other sections: OTHER */}
      {renderSectionItem({
        title: "Other",
        sectionName: "OTHER",
        isSummarized: false,
      })}
      <CaseDetailConfirmDeleteModal
        modalOpened={confirmDeleteItem !== null}
        setModalOpened={setConfirmDeleteItem}
        onConfirm={handleDeleteItem}
        deleting={deleting}
        title="Are you sure you want to delete?"
        description="This item will be permanently deleted"
      />
    </Box>
  );
};
export default TabPanelTranscription;
